import EmptyState from 'components/EmptyState';
import Spinner from 'components/Spinner';
import React, { } from 'react';
import { useSearchParams } from 'react-router-dom';
import useSWR from 'swr';

// const tabs = ['Weekly prizes', 'Monthly prizes', 'All prizes'];

const leaderboardData = [
    { username: '23 Gidbird', score: 5004 },
    { username: 'colinschmitz', score: 5004 },
    { username: '23 Gidbird', score: 5004 },
    { username: 'jenniferlopez', score: 5004 },
    { username: 'emilydavis', score: 5004 },
    { username: 'emilydavis', score: 5004 },
    { username: 'robertbrown', score: 5004 },
    { username: 'michaeljohnson', score: 5004 },
    { username: 'sarahsmith', score: 5004 },
    { username: 'laurawhite', score: 5004 }
];


const divisibleby2 = !!(leaderboardData.length % 2)
const Prizes = () => {


    const [searchParam] = useSearchParams()
    const id = searchParam.get('game')
    const { data, isValidating } = useSWR(`/promos/give-aways/${id}/prizes`)

    const prizes =
        Object.values(data?.data || {})?.flatMap(item => item?.flatMap(subItem => subItem?.prizes)) ;
    
    return (
        <div className=" mx-auto bg-white rounded-2xl p-4">
            {/* Tabs */}
            {/* <div className="flex gap-2 mb-4">
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        className={`px-4 py-1.5 text-sm rounded-[16px] border transition-colors
        ${activeTab === tab
                                ? 'bg-white border-primary text-primary font-medium'
                                : 'bg-white border-gray-200 text-dark'
                            }`}
                    >
                        {tab}
                    </button>
                ))}
            </div> */}


            {/* Prizes list */}

            {
                isValidating ?
                    <Spinner />
                    :
                    prizes.length === 0 ?
                        <EmptyState title={'No prizes'} />
                        :
                        <div className="text-sm p-3 rounded-[12px]  grid grid-cols-2 gap-x-[24px] ">
                            {prizes.map((item, idx) => (
                                <div
                                    key={item?.id + item.type} 
                                    className="flex items-center py-5 "
                                    style={{
                                        borderBottom: idx < leaderboardData.length - (divisibleby2 ? 1 : 2) ? '1px dashed #E5E7EB' : 'none'
                                    }}
                                >
                                    <img
                                        src={item?.image}
                                        alt={item.name}
                                        className="w-16 h-16 rounded-[12px] mr-4"
                                    />
                                    <div className="flex-1">
                                        <div className="font-medium">{item.name}</div>
                                    </div>

                                </div>
                            )

                            )}

                        </div>}

        </div>
    );
};

export default Prizes;
